import React, {Suspense, lazy} from 'react';
import {ROUTE_WHATSAPP_CONSENT_REPORT} from '@app/navigations/RoutePathConstant';
import {authLoader} from '@app/navigations/loader';
import {Spin} from 'antd';

const WhatsappConsentReport = lazy(() =>
  import('../../../screens/WhatsappConsentReport')
    .then(module => ({default: module.WhatsappConsentReport})));

const WhatsappConsentReportNavigation = [
  {
    path: ROUTE_WHATSAPP_CONSENT_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <WhatsappConsentReport />
      </Suspense>
    ),
  },
];

export default WhatsappConsentReportNavigation;
